import type { RefObject } from 'react'
import type ReactECharts from 'echarts-for-react'

export function useExportChartImage(chartRef: RefObject<ReactECharts | null>, filename: string) {
  return () => {
    const instance = chartRef.current?.getEchartsInstance()
    if (!instance) return

    const dataUrl = instance.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#ffffff' })
    const a = document.createElement('a')
    a.href = dataUrl
    a.download = `${filename}.png`
    a.click()
  }
}
